import { DownloadingModalComponent } from './../../components/modals/downloading-modal/downloading-modal.component';
import { CommunicationService } from './../../Services/communication.service';
import { RoutingService } from './../../Services/routing.service';
import { StorageService } from './../../Services/storage.service';
import { ActivityLogModalComponent } from './../../components/modals/activity-log-modal/activity-log-modal.component';
import { AdminTreeComponent } from '../../components/Pages/admin-tree/admin-tree.component';
import { UsersPanelComponent } from '../../components/Pages/users-panel/users-panel.component';
import { RequestsTableComponent } from '../../components/Pages/requests-table/requests-table.component';
import { LangChangesModalComponent } from './../../components/modals/lang-changes-modal/lang-changes-modal.component';
import { UserDto } from './../../models/dto/user.dto';
import { HelperService } from './../../Services/helper.service';
import { TranslateService } from '@ngx-translate/core';
import { InfoModalComponent } from './../../components/modals/info-modal/info-modal.component';
import { PassChangesModalComponent } from './../../components/modals/pass-changes-modal/pass-changes-modal.component';
import { AuthService } from './../../Services/auth.service';
import { AfterViewInit, Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import { NavigationEnd, ResolveEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HttpService } from '../../Services/http.service';
import { CustomerAndOrganizations } from '../../models/customer-and-organizations.model';
import { BehaviorSubject } from 'rxjs';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import Config from '../../../config.json';
import { Constants } from '../../../constants';
import { environment } from './../../../environments/environment';

const OrganizationForRequests = 'organization-for-requests';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css'],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'organization-select-panel' },
    },
  ]
})
export class AdminLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(PassChangesModalComponent) private passModal: PassChangesModalComponent;
  @ViewChild(InfoModalComponent) private infoModal: InfoModalComponent;
  @ViewChild(LangChangesModalComponent) private langModal: LangChangesModalComponent;
  @ViewChild(ActivityLogModalComponent) private activityLogsModal: ActivityLogModalComponent;
  @ViewChild(DownloadingModalComponent) downloadModal: DownloadingModalComponent;

  profile: UserDto;
  organizations: CustomerAndOrganizations[];
  selectedOrganization = new BehaviorSubject('');
  items: any[];
  intervalId: any
  analysisQueues: any[];
  componentReference: any;
  currentRoute: string;
  selectedAdminMode = false;
  msgModal: string;
  titleModalError: string;
  uploadProgress: number;
  isShowUploadMsg = false;
  isCloseByBtn = false;

  version = Config.VERSION;
  branch = Config.VERSION === 'latest' ? ', ' + Config.BRANCH : '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private helper: HelperService,
    private storage: StorageService,
    private routing: RoutingService,
    private communication: CommunicationService,
    private httpService: HttpService) {
    this.getRouterFromUrl();
    this.intervalId = setInterval(() => {
      this.getAnalysisQueue();
    }, 60_000);
  }

  getRouterFromUrl() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd || event instanceof ResolveEnd))
      .subscribe((event: any) => {
        if (event.url as string === this.currentRoute) return;

        this.currentRoute = event.url as string;
        console.log(`Current route: '${this.currentRoute}'`);
        this.storage.setLastViewedPage(this.currentRoute);
        this.selectedAdminMode = this.routing.isAdminPage(this.currentRoute);
      });
  }

  async toggleClick() {
    const isLastSelectedAdminMode = this.storage.getIsSelectedAdminMode();
    if (this.selectedAdminMode !== isLastSelectedAdminMode) {
      this.storage.setIsSelectedAdminMode(this.selectedAdminMode);
    }
    if (this.selectedAdminMode) {
      await this.router.navigate([Constants.customersPanelPage]);
    } else {
      await this.router.navigate([Constants.analysisRequestPage]);
    }
  }

  get isAnalysisRequestPage() {
    return this.currentRoute.includes(Constants.analysisRequestPage);
  }


  isUsersPanelPage() {
    return this.currentRoute.includes(Constants.usersPanelPage);
  }

  isCustomersPanelPage() {
    return this.currentRoute.includes(Constants.customersPanelPage);
  }

  async goToCustomerPanel() {
    await this.router.navigate([Constants.customersPanelPage]);
  }

  async goToUsersPanel() {
    await this.router.navigate([Constants.usersPanelPage]);
  }

  async logOut() {
    await this.authService.logout();
  }

  changePass() {
    this.passModal.open();
  }

  changeLang() {
    this.langModal.open();
  }

  ngOnInit() {
    this.subscribeUploadingData();
    this.getSelectItems();
    this.getAnalysisQueue()
  }

  subscribeUploadingData() {
    this.selectedOrganization.subscribe((data) => {
      this.organizationChanged({ value: data })
    })
    this.communication.getUploadProgress().subscribe((data: number) => {
      this.uploadProgress = data;
      if (this.uploadProgress && !this.isCloseByBtn) {
        this.isShowUploadMsg = true;
      }
      if (!this.uploadProgress) {
        this.isCloseByBtn = false;
        this.isShowUploadMsg = false;
      }
    })
  }

  getSelectItems() {
    this.items = this.getControlMenuItems();
    this.translate.onLangChange.subscribe(() => {
      this.items = this.getControlMenuItems();
    });
  }

  getControlMenuItems() {
    const items = [
      { url: environment.serviceUrl + this.translate.instant('NAV_BAR.URL_SLUG_USER_MANUAL'), title: this.translate.instant('NAV_BAR.LINK_USER_MANUAL') },
      { url: environment.serviceUrl + this.translate.instant('NAV_BAR.URL_SLUG_LABEL'), title: this.translate.instant('NAV_BAR.LINK_INFO_LABEL') },
    ];
    return items;
  }
  getAnalysisQueue() {
    this.httpService.getAnalysisQueue().subscribe((resp) => {
      const queue: { name: string; count: number; }[] = []
      resp.forEach((q: { analysisType: string; queueSize: number; }) => {
        queue.push({
          name: q.analysisType,
          count: q.queueSize,
        });
      })
      this.analysisQueues = queue;
    });
  }

  closeByBtn() {
    this.isCloseByBtn = true;
    this.isShowUploadMsg = false;
  }

  fileOpen(event: any) {
    if (event?.fileName) {
      this.downloadModal.open();
      this.helper.downloadFile(event.fileName).catch(() => {
        this.showErrorModal();
      }).finally(() => {
        this.downloadModal.close();
      });
    }
  }

  async showErrorModal() {
    const modalMsg = this.translate.instant('REQUEST_TABLE.ERROR_MODAL');
    await this.infoModal.open(modalMsg, null, false);
  }

  async ngAfterViewInit() {
    this.profile = await this.authService.getUserProfile();
    if (this.helper.isPortalAdminOrPortalUserPermission(this.profile)) {
      this.httpService.getAllOrganizations().subscribe((resp) => {
        this.organizations = resp;
      });
      this.selectedOrganization.next(this.getSelectedOrganization());
    }
  }

  async result(result: boolean) {
    const title = this.translate.instant('CONFIRM.SUCCESS_MODAL_TITLE_PASS');
    const titleErr = this.translate.instant('CONFIRM.ERROR_MODAL_PASS');
    if (result) {
      await this.infoModal.open(title, null, true);
     } else {
      await this.infoModal.open(titleErr, null, false);
     }
  }

  onOutletLoaded(component: RequestsTableComponent | UsersPanelComponent | AdminTreeComponent) {
    this.componentReference = component;
    this.organizationChanged({ value: this.selectedOrganization.getValue() })
  }

  makeUploadRequest() {
    if (this.profile?.uploadFormat === 'folder') {
      this.makeFolderRequest();
    } else {
      this.makeFileRequest();
    }
  }

  makeFileRequest() {
    if (this.componentReference instanceof RequestsTableComponent) {
      this.componentReference.clickFileUploadEvent();
    }
  }

  makeFolderRequest() {
    if (this.componentReference instanceof RequestsTableComponent) {
      this.componentReference.clickFolderUploadEvent();
    }
  }

  showActivityLogs() {
    this.activityLogsModal.open();
  }

  organizationChanged(event: any) {
    if (this.helper.isPortalAdminOrPortalUserPermission(this.profile)) {
      localStorage.setItem(OrganizationForRequests, event.value);
      if (this.componentReference instanceof RequestsTableComponent) {
        this.componentReference.applyFilterByOrganizationId(event.value);
      }
    } else {
      // localStorage.removeItem(OrganizationForRequests);
      if (this.componentReference instanceof RequestsTableComponent) {
        this.componentReference.applyFilterByOrganizationId(null);
      }
    }
  }

  getSelectedOrganization(): string {
    if (this.helper.isPortalAdminOrPortalUserPermission(this.profile)) {
      let organization = localStorage.getItem(OrganizationForRequests);
      if (!organization || organization === 'null' || organization === 'undefined') {
        organization = this.profile.organizationId;
      }
      return organization;
    }
    return null;
  }

  get organization() {
    return this.selectedOrganization.getValue()
  }

  set organization(value: string) {
    this.selectedOrganization.next(value);
  }

  get getUserName() {
    return `${this.profile.firstName} ${this.profile.lastName}`;
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId); // cleanup when service/component is destroyed
    }
  }
}
